module.exports = __webpack_public_path__ + "static/freedom-from-the-known-7477f46ad6b53e6a8cc3d85f94ff4715.jpg";